import React, { useState, useEffect } from 'react';

export default function BlankCard(props) {
	// console.log('BlankCard', props);

	return (
		<div className="BlankCard bg-white w-full min-w-96 rounded-md text-gray-800 text-sm md:text-lg">
			{props.children}
		</div>
	);
}
